1
import { Component, OnInit, TemplateRef } from '@angular/core';  
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal'; 

@Component({
  selector: 'app-modal-focus',
  templateUrl: './modal-focus.component.html',
  styleUrls: ['./modal-focus.component.css']
})
export class ModalFocusComponent implements OnInit {

  modalRef: BsModalRef;
   constructor(private modalService: BsModalService) {}
   openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
 }
  ngOnInit(): void {
  }

}
